import { MessageCircle, CalendarCheck } from "lucide-react";
import { waLink } from "../data/site";
import { useLeadModal } from "./LeadModalContext";
import { useLanguage } from "../lib/language";
import { track } from "../lib/track";

export const MobileCTABar = () => {
  const { open } = useLeadModal();
  const { t } = useLanguage();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-dwc-charcoal/20 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
      data-testid="mobile-cta-bar"
    >
      <div className="grid grid-cols-2 gap-px">
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-cta-whatsapp"
        onClick={() => track("whatsapp_click", { source: "sticky_bar" })}
        className="flex items-center justify-center gap-2 bg-white/95 px-4 py-4 text-[13px] font-extrabold uppercase tracking-wide text-dwc-green backdrop-blur-md"
      >
        <MessageCircle className="h-4 w-4" aria-hidden="true" />
        {t.whatsapp}
      </a>
      <button
        onClick={() => open()}
        data-testid="mobile-cta-book"
        className="flex items-center justify-center gap-2 bg-dwc-green px-4 py-4 text-[13px] font-extrabold uppercase tracking-wide text-white"
      >
        <CalendarCheck className="h-4 w-4" aria-hidden="true" />
        {t.bookShort}
      </button>
      </div>
    </div>
  );
};

export const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    onClick={() => track("whatsapp_click", { source: "float" })}
    aria-label="Chat with DWC on WhatsApp"
    className="fixed bottom-6 right-6 z-[60] hidden h-14 w-14 items-center justify-center rounded-full bg-dwc-green text-white shadow-[0_12px_32px_rgba(23,107,58,0.4)] transition-transform duration-300 hover:-translate-y-1 hover:scale-105 md:flex"
  >
    <MessageCircle className="h-6 w-6" aria-hidden="true" />
  </a>
);
